import React from 'react';
import PropTypes from 'prop-types';
import { CriticalSystems } from './CriticalSystems';
import styles from './CriticalSection.module.css';

export const CriticalSection = ({ categories }) => {
  return (
    <div className={styles.container}>
      <h2 className={styles.title}>Critical System Status</h2>
      <div className={styles.list}>
        {categories.map((c) => (
          <CriticalSystems 
            key={c.category} 
            category={c.category} 
            status={c.status} 
          />
        ))}
      </div>
    </div>
  );
};

CriticalSection.propTypes = {
  categories: PropTypes.arrayOf(
    PropTypes.shape({
      category: PropTypes.string.isRequired,
      status: PropTypes.string.isRequired
    })
  ).isRequired
};
